import React from 'react'
import { BrowserRouter, useRoutes, Navigate } from 'react-router-dom'
import Login, { Logout } from 'pages/login'
import App from './App'
import Users from 'pages/users'
import Devices from 'pages/devices'
import Contacts from 'pages/contacts'
import Broadcast from 'pages/broadcast'
import InfoMessages from 'pages/info-messages'
import FeatureGroups from 'pages/feature-groups'
import Apps from 'pages/apps'
import Metrics from 'pages/metrics'
import ActivityLog from 'pages/activity-log'
import DeviceLogs from 'pages/device-logs/DeviceLogs'
import Admins from 'pages/admins'
import Realms from 'pages/realms'
import NotFound from 'components/organisms/NotFound'
import { AuthGuard, RoleGuard } from 'guards'
import { Roles } from 'utils/consts'
import { InstanceGuard } from 'guards/InstanceGuard'
import { isTagline } from 'utils/location'
import Emails from './pages/emails'

function AppRoutes() {
  return useRoutes([
    {
      path: 'login',
      element: <Login />,
    },
    {
      path: '/',
      element: (
        <AuthGuard>
          <App />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to="/users" replace />, index: true },
        {
          path: '/users/',
          element: <Users />,
          children: [
            {
              path: ':id',
            },
          ],
        },
        {
          path: '/devices',
          element: <Devices />,
          children: [
            {
              path: ':id',
            },
          ],
        },
        {
          path: '/contacts/',
          element: <Contacts />,
          children: [
            {
              path: ':id',
            },
          ],
        },
        { path: '/broadcast', element: <Broadcast /> },
        { path: '/info-messages/*', element: <InfoMessages /> },
        {
          path: '/feature-groups/',
          element: <FeatureGroups />,
          children: [
            {
              path: ':id',
            },
          ],
        },
        {
          path: '/apps/',
          element: <Apps />,
        },
        {
          path: '/metrics/',
          element: <InstanceGuard isAllowed={isTagline} />,
          children: [
            {
              path: '',
              element: <Metrics />,
            },
          ],
        },
        {
          path: '/log',
          element: <RoleGuard allowedRoles={[Roles.SuperAdmin, Roles.Admin]} />,
          children: [
            {
              path: '',
              element: <ActivityLog />,
            },
          ],
        },
        {
          path: '/devicelogs',
          element: <RoleGuard allowedRoles={[Roles.SuperAdmin, Roles.Admin]} />,
          children: [
            {
              path: '',
              element: <DeviceLogs />,
            },
          ],
        },
        {
          path: '/emails',
          element: <RoleGuard allowedRoles={[Roles.SuperAdmin, Roles.Admin]} />,
          children: [
            {
              path: '',
              element: <Emails />,
              children: [
                {
                  path: ':id',
                },
              ],
            },
          ],
        },
        {
          path: '/admin',
          element: <RoleGuard allowedRoles={[Roles.SuperAdmin, Roles.Admin]} />,
          children: [
            {
              path: '',
              element: <Admins />,
              children: [
                {
                  path: ':id',
                },
              ],
            },
          ],
        },
        {
          path: '/realms',
          element: <RoleGuard allowedRoles={[Roles.SuperAdmin]} />,
          children: [
            {
              path: '',
              element: <Realms />,
              children: [
                {
                  path: ':id',
                },
              ],
            },
          ],
        },
        { path: '/logout', element: <Logout /> },
        { path: '*', element: <NotFound /> },
      ],
    },
  ])
}

export default function Router() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  )
}
